import React, { useState, useEffect } from 'react';
import { SubmitButton } from './BaseButton';
export function ListSelect({ title, ids, list, sId, sName, setIds }) {
    const [mIds, setmIds] = useState([]) //被選中的列表(只有id)
    const [mItems, setItems] = useState([]) //被選中的列表
    const [mList, setList] = useState([])   //可選列表

    const [mSelect, setSelect] = useState("")



    useEffect(() => {
        if (ids !== undefined && ids !== mIds && list.length > 0) {
            setmIds(ids)
        }
    }, [ids, list])


    useEffect(() => {
        check()
    }, [mIds])

    function check() {
        var items = []
        if (mIds.length === 0) {
            setList(list)
            setItems(items)
        } else {
            mIds.map((id) => {
                var reults = list.filter((element, index, arr) => {
                    //console.log("sId" + element[sId])
                    //console.log("id" + id)
                    return (element[sId] === id)
                })
                //console.log(reults)
                if (reults.length > 0) {
                    items.push(reults[0])
                    list = list.filter(x => x[sId] !== id)
                }
                return true
            })
            setList(list)
            setItems(items)
        }
    }

    function remove(id) {
        var ids = mIds.filter(x => x !== id)
        setmIds(ids)
        if (setIds !== undefined)
            setIds(ids)
    }

    function toAdd() {
        var sIds = mIds.filter(x => x)
        if (mSelect !== "") {
            sIds.push(mSelect)
            if (setIds !== undefined)
                setIds(sIds)
        }
    }


    var content =
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="col-sm-4">
                        <p>{title}</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="col-sm-8">
                        {
                            //console.log(role_Items)
                            mItems.map((item) => (
                                <button key={item[sId]} type="button" onClick={e => remove(item[sId])} className="btn btn-primary m-r-sm">
                                    <i className="fa fa-times"></i>
                                    {item[sName]}
                                </button>
                            ))
                        }
                    </div>

                    <div className="col-sm-4 text-right">
                        <div className="row">
                            <div className="col-sm-8">
                                <select className="input-md form-control input-s-sm inline" onChange={e => setSelect(e.target.value)}>
                                    <option >請選擇</option>
                                    {
                                        mList.map((item) => (
                                            <option key={item[sId]} value={item[sId]}>{item[sName]}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-sm-4">
                                <SubmitButton action={toAdd} icon={"fa-check"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    return (
        <>
            {content}
        </>
    )
}